import { render, staticRenderFns } from "./NewBankInfo.vue?vue&type=template&id=de2c3c66&"
import script from "./NewBankInfo.vue?vue&type=script&lang=js&"
export * from "./NewBankInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports